module.exports = __webpack_public_path__ + "assets/img/enginio_header_mobile.f3f0dc93.png";